/* Only Approved — scroll to results AFTER a collection filter/sort update (passive, conflict-free) — 2026-06-19 v6 */
(function () {
  try {
    var section = document.querySelector('[data-section-type="collection"]');
    if (!section) return;
    var content = section.querySelector('.collection__content') ||
                  section.querySelector('[data-results-container]') || section;
    var TUCK = 12; // px to tuck the divider up under the header (raise to hide more, lower to show more)

    function pinnedH(el) {
      if (typeof el === 'string') el = document.querySelector(el);
      if (!el) return 0;
      var p = getComputedStyle(el).position;
      return (p === 'sticky' || p === 'fixed') ? Math.round(el.getBoundingClientRect().height) : 0;
    }
    function cssVarPx(name) {
      var v = getComputedStyle(document.documentElement).getPropertyValue(name);
      var n = parseFloat(v);
      return (isNaN(n) || n <= 0) ? 0 : Math.round(n);
    }
    function headerH() {
      var v = cssVarPx('--header-desktop-sticky-height');
      if (v) return v;
      return pinnedH('.header__outer-wrapper') || pinnedH('[data-section-type="header"]') ||
             pinnedH('.header') || pinnedH('header');
    }
    function stickyTop() {
      var bar = section.querySelector('.filter-topbar-wrap') || section.querySelector('[data-filter-topbar]');
      return headerH() + pinnedH(bar);
    }
    function scrollToResults() {
      // v4 structure (which scrolled correctly): absolute target + "only scroll up to it" guard
      var top = content.getBoundingClientRect().top + window.pageYOffset - stickyTop() + TUCK;
      top = Math.max(0, Math.round(top));
      if (window.pageYOffset <= top + 4) return; // already at/above the target
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    var timer = null;
    function schedule() { if (timer) clearTimeout(timer); timer = setTimeout(scrollToResults, 140); }

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type !== 'childList') continue;
        if (m.removedNodes.length === 0) continue; // ignore pure appends (infinite scroll)
        var t = m.target;
        if (t && t.closest && t.closest('[data-results-container]')) { schedule(); return; }
      }
    });
    observer.observe(section, { childList: true, subtree: true });
  } catch (e) { /* never break the page */ }
})();